import React, { useRef, useState, useContext } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import Products from "../Product"
import AppContext from "../../context";


// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./styles.css";

// import required modules
import { Pagination, Navigation } from "swiper";

export default function CarouselProductsTopSale() {
  const data = useContext(AppContext.AppCtx); 
  const products:any[] = data.products
  return (
    <div className="carouselTopSale">
      <h1>PRODUCTOS MÁS VENDIDOS</h1>
      <Swiper
        slidesPerView={3}
        centeredSlides={false}
        spaceBetween={0}
        pagination={{
          type: "fraction",
        }}
        navigation={true}
        modules={[Pagination, Navigation]}
        className="mySwiper"
        >
                  {products ? (
          products.map((product) => <SwiperSlide><Products  product={product} /></SwiperSlide>)
        ) : (
          <></>
        )}
      </Swiper>
    </div>
  );
}
